var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVueJsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    viewBox: "0 0 59 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.2604 0L29.5 11.8307L22.7396 0H0L29.5 51.1641L59 0H36.2604Z",
    fill: "#42B883"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2603 0L29.4998 11.8307L22.7394 0H11.8306L29.4998 30.7292L47.1691 0H36.2603Z",
    fill: "#35495E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVueJsLogo);
export default __webpack_public_path__ + "static/media/vue-js-logo.96aa655f4d7977da68281d9f59905d1b.svg";
export { ForwardRef as ReactComponent };